import { FormEvent, useState } from "react";

import { referralPortalClient } from "@/services/referralPortalClient";
import { normalizePhoneForStorage } from "@/utils/phone";

import "./referralPortal.css";

export default function ReferralPortalJoinPage() {
  const [form, setForm] = useState({
    email: "",
    fullName: "",
    phone: "",
    company: "",
    notes: "",
  });
  const [status, setStatus] = useState("");
  const [statusTone, setStatusTone] = useState<"info" | "success" | "warning" | "danger">("info");
  const [isSubmitting, setIsSubmitting] = useState(false);

  function updateField(field: keyof typeof form, value: string) {
    setForm((prev) => ({ ...prev, [field]: value }));
  }

  function formatPhoneField() {
    setForm((prev) => ({
      ...prev,
      phone: normalizePhoneForStorage(prev.phone) || "",
    }));
  }

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      const result = await referralPortalClient.requestAccess(form);
      setStatusTone("success");
      setStatus(`${result.message} Request #${result.accessRequestId} has been recorded.`);
    } catch (error) {
      setStatusTone("danger");
      setStatus((error as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="referral-portal">
      <div className="referral-portal__shell">
        <div className="referral-portal__layout">
          <section className="referral-portal__panel">
            <div className="referral-portal__eyebrow">Join</div>
            <h1>Request portal access</h1>
            <p>
              This path is for existing clients whose contact email is not yet enabled in the portal.
              The request lands inside the shared PMapp database so Linfinity can review and onboard it there.
            </p>
          </section>

          <aside className="referral-portal__card">
            <form className="referral-portal__form" onSubmit={handleSubmit}>
              <div className="referral-portal__form-grid">
                <div className="referral-portal__field">
                  <label htmlFor="join-email">Email</label>
                  <input id="join-email" type="email" value={form.email} onChange={(e) => updateField("email", e.target.value)} required />
                </div>
                <div className="referral-portal__field">
                  <label htmlFor="join-fullName">Full name</label>
                  <input id="join-fullName" value={form.fullName} onChange={(e) => updateField("fullName", e.target.value)} />
                </div>
                <div className="referral-portal__field">
                  <label htmlFor="join-phone">Phone</label>
                  <input id="join-phone" type="tel" value={form.phone} onChange={(e) => updateField("phone", e.target.value)} onBlur={formatPhoneField} />
                </div>
                <div className="referral-portal__field">
                  <label htmlFor="join-company">Company</label>
                  <input id="join-company" value={form.company} onChange={(e) => updateField("company", e.target.value)} />
                </div>
              </div>
              <div className="referral-portal__field">
                <label htmlFor="join-notes">Notes</label>
                <textarea id="join-notes" value={form.notes} onChange={(e) => updateField("notes", e.target.value)} placeholder="Anything Linfinity should know about this access request" />
              </div>
              {status ? (
                <div className={`referral-portal__status referral-portal__status--${statusTone}`}>{status}</div>
              ) : null}
              <button className="referral-portal__button" type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Submitting..." : "Submit access request"}
              </button>
            </form>
          </aside>
        </div>
      </div>
    </div>
  );
}
